import $ from 'expose-loader?exposes=$,jQuery!jquery'
import { hideDropzone, showDropzone } from './ui'
import Uppy from '@uppy/core'
import XHR from '@uppy/xhr-upload'
import DropTarget from '@uppy/drop-target'
import FileList from './uppy/fileList.jsx'

export function parseFormPlaceholders(flg) {
  $(flg).find('input.form-control').each(function () {
    const s = $(this),
      h = s.val().length > 0,
      f = s.is(':focus')
    s.closest('.form-label-group').toggleClass('freeze', (h || f))
  })
}

export function enableSubmit() {
  $('#submitbutton').addClass('btn-success')
    .removeClass('disabled')
    .removeClass('btn-inverse')
    .prop('disabled', '')
}

export function disableSubmit() {
  $('#submitbutton').removeClass('btn-success')
    .addClass('disabled')
    .addClass('btn-inverse')
    .prop('disabled', 'disabled')
}

export function checkI(element) {
  const td = $(element).parent()
  if ($(element).is(':checked'))
    $(td).find('input.config_val').removeAttr('disabled')
  else
    $(td).find('input.config_val').attr('disabled', 'disabled')
}

export function bindFileUpload() {
  const self = $(this)
  const token = $('meta[name="csrf-token"]').attr('content')

  const uppy = new Uppy(
    {
      autoProceed: true,
      meta: {
        _v: 2
      }
    }
  )
    .use(DropTarget, {
      target: this,
      onDragOver: showDropzone,
      onDragLeave: hideDropzone,
      onDrop: hideDropzone
    })
    .use(FileList, {
      target: '#dropzonecontainer'
    })
    .use(XHR, {
      endpoint: self.data('url') + (token ? '&security_token=' + token : ''),
      formData: true,
      fieldName: 'attachments[]',
      allowedMetaFields: [],
      bundle: true,
      withCredentials: true
    })

  self.find('#file-upload').on('change', event => {
    const files = Array.from(event.target.files)

    files.forEach((file) => {
      try {
        uppy.addFile({
          source: 'file input',
          name: file.name,
          type: file.type,
          data: file,
        })
      } catch (err) {
        console.log(err)
      }
    })

    let container = new DataTransfer()
    event.target.files = container.files
  })

  uppy
    .on('upload', () => {
      disableSubmit()
    }).on('upload-success', (file, response) => {
      uppy.setFileMeta(file.id, response.body[0])
    }).on('complete', result => {
      enableSubmit()
    })
}
